export const API_URLS = {
  resellerProfile: "reseller_app/reseller-profile-details/",
  resellerState: "state-list-data/",
  resellerCity: "city-list-data/",
  resellerStoreList: "reseller_app/reseller-store-data-list/",
  specificationTypes: "api/admin/product-specification-type-api/",
  specifications: "api/admin/product-specification-api/",
  category: "api/admin/category-admin-api/",
  subCategory: "api/admin/subcategory-admin-api/",
  brandList: "api/admin/brand-admin-api/",
  productApi: "api/admin/product-admin-api/",
  productVariantApi: "api/admin/product-variant-admin-api/",
  colorVariantApi: "api/admin/type-one-variant-value-api/",
  conectvityVariantApi: "api/admin/type-four-variant-value-api/",
  colorTypeApi: "api/admin/type-one-variant-api/",
  storageVariantApi: "api/admin/type-two-variant-value-api/",
  storageTypeApi: "api/admin/type-two-variant-api/",
  otherVariantApi: "api/admin/type-three-variant-value-api/",
  otherTypeApi: "api/admin/type-three-variant-api/",
  connectivityTypeApi: "api/admin/type-four-variant-api/",
  screensizeVariantApi: "api/admin/type-five-variant-value-api/",
  screensizeTypeApi: "api/admin/type-five-variant-api/",

  uploadVariantByExcelApi:
    "api/admin/upload-product-variant-by-excel-admin-api/",
  multipleImageApi: "api/admin/product-variant-multiple-image-admin-api/",
  product_specification: "product-variant-specification-admin-api",
  variantListCopy: "api/admin/copy-product-variant-specification-admin-api/",
  variantCombo: "api/admin/create-possible-product-variant-combination-admin/",
  variantSelectImage: "api/admin/copy-product-variant-image-admin-api/",
  codManagement: "api/admin/set-cod-amount-api/",

  rating_review: "api/admin/customer-order-give-product-review-api-for-admin/",
  page_ui: "api/admin/page-design-setup-api/",
  generate_specification:
    "api/admin/generate-specification-sample-api-of-bhaaraterp/",
  add_specification: "api/admin/upload-specification-excel-api-of-bhaaraterp/",

  generate_specification_value:
    "api/admin/generate-sample-format-specification-type-excel-api-of-bhaaraterp/",
  add_specification_value:
    "api/admin/upload-specification-type-excel-api-of-bhaaraterp/",

  sub_category: "api/admin/multivendor-show-sub-category-list/",

  headerList: "api/store/customization-header/",
};
